<template>
  <div
    id="app"
    v-loading.fullscreen.lock="loading"
  >
    <router-view :class="classes" />

    <!-- job progress view -->
    <em-job-overlay
      v-if="showJobProgress"
      :job-id="showJobProgress.job_id"
      :success-message="jobProgressSuccessMessage"
      :waiting-message="jobProgressWaitingMessage"
      @failure="onFailure"
    />
  </div>
</template>

<style lang="stylus" src="./styles/app.styl"></style>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import EmJobOverlay from './components/EmJobOverlay'
  import router from './router'

  export default {
    name: 'App',
    components: { EmJobOverlay },
    computed: {
      ...mapGetters('ui', [
        'loading',
        'showJobProgress'
      ]),

      classes () {
        return {
          blurry: !!this.showJobProgress
        }
      },

      jobProgressWaitingMessage () {
        return this.showJobProgress.waiting_message || 'We are super busy working on your jobs – stay tuned, or close the window'
      },

      jobProgressSuccessMessage () {
        return this.showJobProgress.success_message || 'Wohoo – we have finished all your jobs... Thanks for watching.'
      }
    },
    methods: {
      ...mapActions('ui', [
        'setShowJobProgress'
      ]),

      onFailure (error) {
        router.push({
          name: 'failure',
          params: { error }
        })

        this.setShowJobProgress(false)
      }
    }
  }
</script>
